// Mutation hook - twarde usuniecie pojedynczego Notify (z zalacznikami).
// DELETE /api/ui/sales-crm/notify/{id}
// Sprint 3 v4.1. NIE myl z DELETE /notify/threads/{threadId} (cale watki).

import { axios } from 'api';
import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';
import type { IDeleteNotifyResponse } from 'api/types/notify';

export interface IUseDeleteNotifyParams {
  notifyId: number;
  dealId?: number;
  threadId?: number;
}

const deleteNotify = (params: IUseDeleteNotifyParams): Promise<IDeleteNotifyResponse> =>
  axios.delete(`/sales-crm/notify/${params.notifyId}`);

export const useDeleteNotify = (
  options?: UseMutationOptions<IDeleteNotifyResponse, IError, IUseDeleteNotifyParams>
) => {
  const queryClient = useQueryClient();
  return useMutation<IDeleteNotifyResponse, IError, IUseDeleteNotifyParams>(deleteNotify, {
    ...options,
    onSuccess: async (data, variables, context) => {
      if (variables.dealId) {
        await queryClient.invalidateQueries(['sales-crm-notify', 'by-deal', variables.dealId]);
        await queryClient.invalidateQueries(['sales-crm-notify', 'threads', 'by-deal', variables.dealId]);
      }
      if (variables.threadId) {
        await queryClient.invalidateQueries(['sales-crm-notify', 'by-thread', variables.threadId]);
      }
      options?.onSuccess?.(data, variables, context);
    }
  });
};
